import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { XCircle } from 'lucide-react';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-xl">
        <CardContent className="p-8 text-center">
          <div className="bg-yellow-100 rounded-full p-4 w-24 h-24 mx-auto mb-4 flex items-center justify-center">
            <XCircle className="h-16 w-16 text-yellow-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h2>
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          <p className="text-sm text-gray-500 mb-6">
            You can still use TurboBooks with your current plan. Upgrade anytime to unlock premium features.
          </p>
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/settings')}
              className="w-full bg-blue-600 hover:bg-blue-700"
            >
              Back to Settings
            </Button>
            <Button 
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full"
            >
              Go to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionCancel;
